// Tenant-aware navigation utilities
export const getTenantBasePath = (tenantType) => {
  if (tenantType === 'employee') {
    return '/employee';
  }
  return '/auth/login';
};

export const getTenantSpecificRoute = (tenantType, route) => {
  const basePath = getTenantBasePath(tenantType);

  // If it's the root route, return just the base path
  if (route === '/' || route === '') {
    return basePath;
  }

  // Remove leading slash if present
  const cleanRoute = route.startsWith('/') ? route.slice(1) : route;

  return `${basePath}/${cleanRoute}`;
};

export const isValidTenantRoute = (tenantType, pathname) => {
  const basePath = getTenantBasePath(tenantType);
  return pathname.startsWith(basePath);
};

// Route mappings for different tenants
export const TENANT_ROUTES = {
  employee: {
    dashboard: '/employee'
  }
};

export const getAvailableRoutes = (tenantType) => {
  return TENANT_ROUTES[tenantType] || {};
}; 